import { render } from "./MediaContent.vue?vue&type=template&id=20747e76&scoped=true"
import script from "./MediaContent.vue?vue&type=script&lang=js"
export * from "./MediaContent.vue?vue&type=script&lang=js"

import "./MediaContent.vue?vue&type=style&index=0&id=20747e76&scoped=true&lang=css"
import "./MediaContent.vue?vue&type=style&index=1&id=20747e76&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20747e76"]])

export default __exports__